import { ExternalLink } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const ExternalLinkIcon = DeckardIconWrapper({ Icon: ExternalLink });
